module.exports = __webpack_public_path__ + "static/media/zeya_cry.6ad2b35c.gif";